import { Navigate, Route, Routes } from 'react-router-dom';
import BreakfastSection from '../pages/room-service/BreakfastSection';
import LunchDinnerSection from '../pages/room-service/LunchDinnerSection';
import { OrdersFoodSection } from '../pages/room-service/OrdersFoodSection';
import RefillMiniBarSection from '../pages/room-service/RefillMiniBarSection';
import { RoomSericeMain } from '../pages/room-service/RoomSericeMain';
import SelectManyFood from '../pages/room-service/views/SelectManyFood';
import { SelectOneFood } from '../pages/room-service/views/SelectOneFood';

export const RoomServicesRouter = () => {
    return (
        <Routes>
            <Route path="/*" element={<RoomSericeMain />}>
                <Route path="breakfast" element={<BreakfastSection />} />
                <Route path="lunch" element={<LunchDinnerSection />} />
                <Route path="refill" element={<RefillMiniBarSection />} />
                <Route path="orders" element={<OrdersFoodSection />} />
                <Route path="" element={<Navigate to="breakfast" />} />
            </Route>
            <Route path="/detail/1" element={<SelectOneFood />} />
            <Route path="/detail/2" element={<SelectManyFood />} />
        </Routes>
    );
};
